import React, { Component } from 'react';
import ParameterMod from './ParameterMod';
import NewParameterMod from './NewParameterMod';

class EffectMods extends Component {
    get parameterMods() {
        let mods = [];
        this.props.parameters.forEach(p => mods = mods.concat(p.parameterMods));
        return mods;
    }

    render() {
        return (
            <div>
              {this.parameterMods.map(
                  (parameterMod, i) =>
                      <ParameterMod key={'mod-' + i + '-' + parameterMod.parameter.id} parameterMod={parameterMod}/>
              )}
            </div>
        );
    }
}

export default EffectMods;
